import { Truck, Store } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { euro } from "@/lib/api";

export const SHIPPING_PRICE = 350;
export const CONTACT_EMAIL = "amministrazione@bcaitaliasrl.com";

export const ShippingInfo = () => (
  <div className="flex gap-3 p-4 rounded-xl bg-blue-50 border border-blue-100" data-testid="shipping-info">
    <Truck size={20} className="text-blue-600 shrink-0" />
    <p className="text-sm text-blue-900">
      <span className="font-semibold">Spedizione in tutta Italia a {euro(SHIPPING_PRICE)} IVA inclusa</span>, consegna in massimo 7 giorni lavorativi.
    </p>
  </div>
);

const Option = ({ active, onClick, icon: Icon, title, text, id }) => (
  <button type="button" onClick={onClick} data-testid={id}
    className={`text-left p-3 rounded-xl border-2 transition-colors duration-200 ${active ? "border-blue-600 bg-blue-50" : "border-slate-200 hover:border-slate-300"}`}>
    <Icon size={18} className={active ? "text-blue-600" : "text-slate-500"} />
    <p className="text-sm font-semibold mt-1">{title}</p>
    <p className="text-xs text-slate-500">{text}</p>
  </button>
);

export const DeliveryPicker = ({ value, onChange }) => (
  <div className="space-y-3" data-testid="delivery-picker">
    <div className="grid grid-cols-2 gap-3">
      <Option id="delivery-option-ritiro" active={value.delivery === "ritiro"} onClick={() => onChange({ ...value, delivery: "ritiro" })}
        icon={Store} title="Ritiro in sede" text="Gratuito" />
      <Option id="delivery-option-spedizione" active={value.delivery === "spedizione"} onClick={() => onChange({ ...value, delivery: "spedizione" })}
        icon={Truck} title="Spedizione in Italia" text={`${euro(SHIPPING_PRICE)} IVA incl. · max 7 gg lavorativi`} />
    </div>
    {value.delivery === "spedizione" && (
      <Textarea data-testid="delivery-address-input" rows={2} placeholder="Indirizzo di consegna (via, numero, CAP, città, provincia)"
        value={value.address} onChange={(e) => onChange({ ...value, address: e.target.value })} />
    )}
  </div>
);

export const deliveryValid = (v) => v.delivery === "ritiro" || v.address.trim().length > 5;

export const DeliveryLabel = ({ item }) =>
  item.delivery === "spedizione"
    ? <span className="block text-xs text-blue-700">Spedizione {euro(item.shipping_cost)} · {item.address}</span>
    : <span className="block text-xs text-slate-500">Ritiro in sede</span>;
